export const LinkStyle = { color: "inherit", textDecoration: "inherit" };

export const NavStyle = {
  backgroundColor: "rgb(13, 31, 24)",
  color: "#FFFFFF",
  boxShadow: "none",
 
  borderColor: "rgb(13, 31, 24)",
};